import { createAction } from '@reduxjs/toolkit';

export const setApplicationState = createAction('setApplicationState');

export const resetApplicationState = createAction('resetApplicationState');
export const toggleRelatedArticleListingModal = createAction('toggleRelatedArticleListingModal');
